<template>
    <!-- 31学术会议-->
    <div class="academic-list-section">
        <div class="academic-list-section-box" @click="go(dataItem)">
            <div class="academic-list-section-box-top">
                <img :src="dataItem.content.cover_img" alt="" />
                <div class="academic-list-section-box-zl1" v-if="dataItem.content.academic_origin_type == 14">
                    <img v-if="dataItem.content.meeting_status== 0" src="static/v4/icon_list_tag_live_count_down.svg"/>
                    <img v-else-if="dataItem.content.meeting_status== 1" src="static/v4/icon_list_tag_academic_process.svg" />
                    <img v-else-if="dataItem.content.meeting_status== 2" src="static/v4/icon_list_tag_academic_end.svg"/>
                </div>
                <div class="academic-list-section-box-zl1" v-else-if="dataItem.content.academic_origin_type == 4">
                    <img v-if="dataItem.content.live_status== 0" src="static/v4/icon_list_tag_live_count_down.svg"/>
                    <img v-else-if="dataItem.content.live_status== 1" src="static/v4/icon_list_tag_academic_process.svg" />
                    <img v-else-if="dataItem.content.live_status== 2" src="static/v4/icon_list_tag_academic_end.svg"/>
                </div>
                <div class="academic-list-section-box-btn" v-if="dataItem.content.academic_origin_type == 14 && dataItem.content.meeting_status != 2">
                    <span v-if="dataItem.content.isApply" class="meeting-list-box-img-btn-span1">已报名</span>
                    <span v-else class="meeting-list-box-img-btn-span2" @click.stop="go(dataItem)">报名参会</span>
                </div>
            </div>
            <div class="academic-list-section-box-title" v-html="dataItem.content.title"></div>
            <div class="academic-list-section-box-time">{{ dataItem.content.start_at }}</div>
        </div>
    </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
    name: "academic",
    props: {
        dataItem: {
            type: Object,
            required: true
        }
    },
    methods: {
        go(item){
            // return
            if (item.content.academic_origin_type == 4) {
                // 直播
                Interface.goLiveDetail(this,item.content)
            } else if (item.content.academic_origin_type == 31 || item.content.academic_origin_type == 14) {
                // 会议
                Interface.goMeeting(this,item.content)
            } else if (item.content.academic_origin_type == 13) {
                this.$router.push({name: 'topic-detail', params: { id: item.content.id }})
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/components/academic-list-new.scss";
.academic-list-section{
    width: 355px;
    background: #fff;
    padding: 0;
    margin: 0 auto;
    padding-bottom: 16px;
    margin-top: 10px;
    border-radius: 8px;
    &-box{
        width: 355px;
        &-top{
            position: relative;
            width: 355px;
            img{

                width: 355px;
                height: 200px;
            }
        }
        &-title{
            padding: 0 14px;
        }
        &-time{
            padding: 0 14px;
        }
        &-zl1{
            position: absolute;
            left: 0;
            top: 0;
            img{
                width: 40px;
                height: 18px;
                border-radius: 6px 2px 6px 2px;
            }
        }
        /deep/ .light {
            color: #D81D20;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/academic.vue